export const apiBase = '/api';

import { auth } from '../firebase';

async function http(path, { method = 'GET', body } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  // Attach ID token for admin-guarded endpoints
  try {
    const u = auth.currentUser;
    if (u) {
      const t = await u.getIdToken();
      if (t) headers['Authorization'] = `Bearer ${t}`;
    }
  } catch {}
  const res = await fetch(`${apiBase}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'include'
  });
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = { raw: text } }
  if (!res.ok) {
    const err = new Error(data?.error || `HTTP ${res.status}`);
    err.status = res.status; err.data = data; throw err;
  }
  return data;
}

function buildQuery(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const text = String(value).trim();
    if (!text) return;
    qs.set(key, text);
  });
  const serialized = qs.toString();
  return serialized ? `?${serialized}` : '';
}

export const api = {
  ping: () => http('/ping'),
  checks: (service) => http(`/check/${service}`),
  listLogs: (params = {}) => http(`/logs${buildQuery(params)}`),
  listUsers: () => http('/users'),
  createUser: ({ email, role }) => http('/users', { method: 'POST', body: { email, role } }),
  deleteUser: (uid) => http(`/users/${uid}`, { method: 'DELETE' }),
  disableUser: (uid, disabled = true) => http(`/users/${uid}/disable`, { method: 'POST', body: { disabled } }),
  setRole: ({ uid, role }) => http('/roles', { method: 'POST', body: { uid, role } }),
};
